/* eslint-disable @typescript-eslint/no-explicit-any */
import { all } from "redux-saga/effects";
import complaintsSaga from "./complaints/sagas";
import postsSaga from "./posts/sagas";
import usersSaga from "./users/sagas";

export default function* rootSaga(): any {
  return yield all([postsSaga, complaintsSaga, usersSaga]);
}
